import { SocialMediaPostService } from '@/scripts/services/social-media/social-media-post-service';
import { SocialMediaFileService } from '@/scripts/services/social-media/social-media-file-service';
import { SocialMediaAccountPostService } from '@/scripts/services/social-media/social-media-account-post-service';

export const SocialMediaPostsMixin = {

    methods: {
        // Query methods

        getFilterArrayOfFiles(arrayFiles) {
            let finalQueryReq = '';
            let insideIds = '';
            arrayFiles.forEach((element, index) => {
                if (index === 0) {
                    insideIds = `"${element}"`;
                } else {
                    insideIds += `,"${element}"`;
                }
            });
            finalQueryReq = `Ids=[${insideIds}]`;
            return '?' +  finalQueryReq;
        },

        // Services

        // Get post by id
        getPostDetails(id, clientId) {
            return new Promise((resolve, reject) => {
                SocialMediaPostService.get(id, clientId)
                .then(({ data }) => resolve(data.data))
                .catch(reject);
            });
        },

        // Generate link for upload image
        generateUploadLink(accountId) {
            return new Promise((resolve, reject) => {
                SocialMediaFileService.post(accountId)
                .then(({ data }) => resolve(data.data))
                .catch(reject);
            });
        },

        // Duplicate Files
        bulkDuplicateMedia(payload, clientId) {
            return new Promise((resolve, reject) => {
                SocialMediaPostService.postBulk(clientId, payload)
                .then(({ data }) => resolve(data.data))
                .catch(reject);
            });
        },

        // Upload File
        async uploadFile(service, img, type) {

            const config = {
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': type,
                    'Access-Control-Allow-Origin': '*'
                },
            };
            
            return new Promise((resolve, reject) => {
                SocialMediaPostService.putImage(service, img, config)
                .then(() => resolve({
                    message: 'ok',
                }))
                .catch(reject);
            });
        },

        //Duplicate BlobMedia
        duplicateBlobMedia(payload, accountId) {
            return new Promise((resolve, reject) => {
                SocialMediaFileService.postCopy(accountId, payload)
                .then(({ data }) => resolve(data.data))
                .catch(reject)
            });
        },

        // Delete Files
        deleteFilesInBlob(arrayOfFiles, accountId) {
            const query = this.getFilterArrayOfFiles(arrayOfFiles);
            return new Promise((resolve, reject) => {
                SocialMediaFileService.delete(accountId, query)
                .then((response) => resolve(response))
                .catch(reject);
            });
        },

        // Get base64 for and image with url
        imageOrVideoToBase64(url) {
            return fetch(url)
                .then((response) => response.blob())
                .then(
                    (blob) =>
                        new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () => resolve({ base: reader.result, mime: blob.type });
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                        })
                );
        },

        // Create a post draft
        createPostDraft(args, clientId) {
            const jsonData = {
                postName: args.postName,
                postText: args.postText,
                postCategories: args.postCategories,
                postMediaIds: [],
            };

            if (args.postMediaIds) {
                jsonData.postMediaIds = args.postMediaIds;
            }

            if (args.pageShareUrl !== '') {
                jsonData.pageShareUrl = args.pageShareUrl;
            }
            
            return new Promise((resolve, reject) => {
                SocialMediaPostService.post(clientId, args)
                .then(({ data }) => resolve(data.data))
                .catch(reject);
            });
        },

        // Update Post Draft
        updatePostDraft(idPost, clientId, payload) {
            const jsonData = {
                postName: payload.postName,
                postText: payload.postText,
                postCategories: payload.postCategories,
                pageShareUrl: payload.pageShareUrl,
                postMediaIds: [],
            };

            if (payload.postMediaIds) {
                jsonData.postMediaIds = payload.postMediaIds;
            }


            return new Promise((resolve, reject) => {
                SocialMediaPostService.patch(idPost, clientId, jsonData)
                .then(({ data }) => resolve(data))
                .catch(reject);
            });
        },

        updateWidgetPostDraft(idPost, clientId, payload) {
            const jsonData = {
                postName: payload.postName,
                postCategories: payload.postCategories,
                socialNetworkAccountIds: payload.socialNetworkAccountIds
            };

            return new Promise((resolve, reject) => {
                SocialMediaPostService.patch(idPost, clientId, jsonData)
                .then(({ data }) => resolve(data))
                .catch(reject);
            });
        },

        // Delete post
        deletePostFromAccount(postId, clientId){
            return new Promise((resolve, reject) => {
                SocialMediaAccountPostService.delete(postId, clientId)
                .then(({ data }) => resolve(data))
                .catch(reject);
            });
        },

        // Save or create network version
        savePostNetworkVersion(network, postId, args, versionId = false, clientId) {
            if(network == 'original') { 
                return 'skipped';
            }

            const jsonData = {
                socialNetworkAccountId: parseInt(network),
                socialPostId: parseInt(postId),
                postText: args.postText,
                visibility: args.visibility,
                isScheduled: args.isScheduled,
                postCategories: args.categories,
                pageShareUrl: args.pageShareUrl,
                postMediaIds: [],
            };

            if(args.date) {
                jsonData.date = args.date;
            }

            if (args.postMediaIds) {
                jsonData.postMediaIds = args.postMediaIds;
            }

            return new Promise((resolve, reject) => {
                if (versionId) {
                    SocialMediaAccountPostService.patch(versionId, clientId, jsonData)
                    .then(({ data }) => resolve(data))
                    .catch(reject);
                } else {
                    SocialMediaAccountPostService.post(clientId, jsonData)
                    .then(({ data }) => resolve(data))
                    .catch(reject);
                }
            });
        },

        // publishPost
        publishPost(idPost, clientId) {
            return new Promise((resolve, reject) => {
                SocialMediaPostService.publish(idPost, clientId)
                .then(resolve)
                .catch(reject);
            });
        },

        // Put to Schedule a post
        scheduleAPost(idPost, clientId, payload) {
            return new Promise((resolve, reject) => {
                SocialMediaPostService.putSchedule(idPost, clientId, payload)
                .then(resolve)
                .catch(reject);
            });
        },

        // Put to unschedule a post
        unscheduleAPost(idPost, clientId) {
            return new Promise((resolve, reject) => {
                SocialMediaPostService.putUnschedule(idPost, clientId)
                .then(() => resolve({ message: 'Ok' }))
                .catch(reject);
            });
        },
    },
};